const ImageEquipe = () => {

    return (
        <div className="backstages mb-20 m-auto">
            <h2 className="backstages-title min-[320px]:text-36 xl:text-5xl font-bold min-[320px]:px-0 xl:px-16">
                L'equipe<span>.</span>
            </h2>

            <div className="img-equipe min-[320px]:px-0 xl:px-16 pt-8 max-w-6xl m-auto">
                <img alt="CEO de l'entreprise" src={require("../../img/img-equipe.jpg")}/>
            </div>
        </div>
    );
};

export default ImageEquipe;